// extracted by mini-css-extract-plugin
export default {"cvError":"A--z"};